import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Box,
  Alert,
  Typography,
} from '@mui/material';
import {
  Close as CloseIcon,
} from '@mui/icons-material';
import { 
  Case,
  NavigationProvider
} from '@gekkovet-oy/shared-components';

interface CaseDialogProps {
  open: boolean;
  onClose: () => void;
  caseId?: string;
}

const CaseDialog: React.FC<CaseDialogProps> = ({
  open,
  onClose,
  caseId,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="lg"
      fullWidth
      sx={{
        '& .MuiDialog-paper': {
          height: '95vh',
          minHeight: '600px',
        },
      }}
    >
      <DialogTitle sx={{ m: 0, p: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        Case Management
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ p: 0, height: '100%' }}>
        {caseId ? (
          <Box component={"div"} sx={{ 
            height: '100%', 
            overflow: 'auto',
            position: 'relative' // Needed for absolute positioning of case panel
          }}>
            <NavigationProvider>
              <Case 
                id={caseId}
                onNavigate={(path) => {
                  console.log('Case navigation:', path);
                  // Handle navigation events if needed
                  // For example, you could close the modal and navigate to a specific page
                }}
              />
            </NavigationProvider>
          </Box>
        ) : (
          <Box sx={{ p: 3 }}>
            <Alert severity="info">
              <Typography variant="body1">
                No case selected for this conversation.
              </Typography>
              <Typography variant="body2" sx={{ mt: 1 }}>
                When a case is created or referenced in the chat, it will appear here with full case management features including patient info, symptoms, diagnoses, and treatments.
              </Typography>
            </Alert>
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default CaseDialog;